import { useState, useEffect } from 'react'
import { SpecialOfferAnimation } from './ui'
import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { $userLanguage, $userToken } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import ButtonWrapper from '@/shared/ui/buttonWrapper'
import { AppButton } from '@/shared/ui/button'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { StarterPackItem } from '../starterPackPage/ui/starterPackItem'
import { $specialOfferContent, $specialOfferInfo, getSpecialOfferFx } from '@/entities/payments'
import { RewardRarity } from '@/entities/cases'
import { goToShop } from '@/app/routing/events'

export const StarterPackClaimPage = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const userToken = useUnit($userToken)
  const specialOfferContent = useUnit($specialOfferContent)
  const specialOfferInfo = useUnit($specialOfferInfo)
  const btnTexts = lang[userLang].pages.btnTexts
  const texts = lang[userLang].pages.starterPackClaim
  const rarity = RewardRarity[specialOfferInfo?.rarity ?? 1]
  useHideNav()

  const [animDone, setAnimDone] = useState(false)
  const [shouldAnimate, setShouldAnimate] = useState(false)

  useEffect(() => {
    if (specialOfferInfo?.photo_url && !animDone) {
      setShouldAnimate(true)
    } else {
      setShouldAnimate(false)
    }
  }, [specialOfferInfo, animDone])

  if (shouldAnimate) {
    return (
      <SpecialOfferAnimation
        onComplete={() => {
          setAnimDone(true)
          setShouldAnimate(false)
        }}
      />
    )
  }

  const handleClick = () => {
    goToShop({ tab: 0 })
    if (userToken) {
      getSpecialOfferFx(userToken)
    }
  }

  return (
    <div className={classes.root} data-rarity={rarity}>
      <span className={classes.heading}>{texts.heading}</span>
      <span className={classes.subHeading}>{texts.subHeading}</span>
      <div className={classes.starterPackList}>
        {specialOfferContent !== null &&
          specialOfferContent.map((item) => (
            <StarterPackItem {...item} key={item.name} contentLength={specialOfferContent.length} />
          ))}
      </div>
      <ButtonWrapper style={{ left: '0', zIndex: 20 }}>
        <AppButton className={classes.button} onClick={handleClick}>
          {btnTexts.time}
        </AppButton>
      </ButtonWrapper>
    </div>
  )
}
